/**
 * Fills a `{token}` placeholder in a translated string.
 *
 * `t()` returns the key itself when a string has not been localised yet, and a key contains no
 * placeholder — so a plain `.replace()` would quietly leave a snake_case key on the page. Undefined
 * in that case, so each caller picks the fallback that reads right in its place (a generic
 * heading, the bare carrier name) instead of one fallback fitting none of them.
 */
export const interpolate = (template: string, token: string, value: string): string | undefined => {
  const placeholder = `{${token}}`;

  return template.includes(placeholder) ? template.replaceAll(placeholder, value) : undefined;
};
